import { useMutation } from '@apollo/client'
import * as React from 'react'
import { Input, Button, Content } from 'components'
import styled from 'styled-components'
import { useTranslation } from 'i18n'
import { UPDATE_PASSWORD } from 'request/apollo/queries/account'
import { useMessage } from 'components/Message/useMessage'

const initialState = {
  old: '',
  new: '',
  confirm: '',
}

type Props = {}

const Component: React.FC<Props> = ({}) => {
  const { t } = useTranslation('accountPassword')
  const [inputs, setInputs] = React.useState(initialState)
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState(null)
  const [mutate] = useMutation(UPDATE_PASSWORD)
  const { sendMessage } = useMessage()

  const onSubmit = () => {
    setLoading(true)
    setError(null)
    mutate({ variables: inputs })
      .then(() => {
        setInputs(initialState)
        setLoading(false)
        sendMessage(t('changedPassword'), 'info')
      })
      .catch(error => {
        setLoading(false)
        setError(error)
        throw error
      })
  }

  return (
    <Content.Base>
      <h1>{t('changePassword')}</h1>
      <InputTextWrapper>
        <Input.Error>{error}</Input.Error>
        <Input.Default
          fullWidth
          type="password"
          title={t('currentPassword')}
          value={inputs.old}
          onChange={e => setInputs({ ...inputs, old: e.currentTarget.value })}
        />
        <Input.Default
          fullWidth
          type="password"
          title={t('newPassword')}
          value={inputs.new}
          onChange={e => setInputs({ ...inputs, new: e.currentTarget.value })}
        />
        <Input.Default
          fullWidth
          type="password"
          title={t('confirmNewPassword')}
          value={inputs.confirm}
          onChange={e =>
            setInputs({ ...inputs, confirm: e.currentTarget.value })
          }
        />
      </InputTextWrapper>
      <ButtonWrapper>
        <Button.Default
          loading={loading}
          fullWidth
          color="primary"
          onClick={onSubmit}
        >
          {t('saveChanges')}
        </Button.Default>
      </ButtonWrapper>
    </Content.Base>
  )
}

export default Component

const InputTextWrapper = styled.div`
  padding-top: 20px;
`

const ButtonWrapper = styled.div`
  padding-top: 50px;
`
